import React from "react";
import {
  usePromotionalMessage,
  PromotionalTabs,
  UserSearchSection,
  MessageContentSection,
  SendToAllWarning,
} from "../../components/PromotionalMessage";
import { AlertMessage } from "../../components/Notification";

export default function PromotionalMessage() {
  const {
    activeTab,
    setActiveTab,
    searchEmail,
    setSearchEmail,
    searchContactNo,
    setSearchContactNo,
    searchedUser,
    message,
    setMessage,
    selectedImage,
    imagePreview,
    selectedVideo,
    videoPreview,
    url,
    setUrl,
    loading,
    searching,
    error,
    successMsg,
    clearFeedback,
    handleImageChange,
    handleRemoveImage,
    handleVideoChange,
    handleRemoveVideo,
    handleSearchUser,
    handleSendToSpecificUser,
    handleSendToAllUsers,
  } = usePromotionalMessage();

  const hasContent = message || selectedImage || selectedVideo || url;

  return (
    <div className="p-3 sm:p-4 w-full min-w-0 overflow-x-hidden">
      <header className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 mb-4">
        <h2 className="text-lg md:text-2xl font-bold text-gray-800">
          Promotional Messages
        </h2>
        {successMsg && (
          <div className="text-green-700 bg-green-100 px-4 py-2 rounded-lg text-sm font-medium border border-green-200 shrink-0">
            {successMsg}
          </div>
        )}
      </header>

      <PromotionalTabs
        activeTab={activeTab}
        onTabChange={setActiveTab}
        onTabClick={clearFeedback}
      />

      {error && (
        <AlertMessage variant="error" message={error} title="Error:" />
      )}
      {loading && (
        <AlertMessage
          variant="loading"
          message={
            activeTab === "specific"
              ? "Sending message..."
              : "Sending to all users..."
          }
        />
      )}

      {activeTab === "specific" && (
        <div className="bg-white p-4 sm:p-6 rounded-xl shadow-xl min-w-0 overflow-x-hidden">
          <h3 className="text-base md:text-xl font-bold text-gray-800 mb-4 sm:mb-6">
            Send Promotional Message to Specific User
          </h3>

          <UserSearchSection
            searchEmail={searchEmail}
            setSearchEmail={setSearchEmail}
            searchContactNo={searchContactNo}
            setSearchContactNo={setSearchContactNo}
            onSearch={handleSearchUser}
            searching={searching}
            onClearError={clearFeedback}
            searchedUser={searchedUser}
          />

          <div className="border-t border-gray-200 pt-6">
            <h4 className="text-base md:text-lg font-bold mb-4 text-gray-800">
              Message Content
            </h4>
            <MessageContentSection
              idPrefix="specific"
              message={message}
              onMessageChange={setMessage}
              selectedImage={selectedImage}
              imagePreview={imagePreview}
              onImageChange={handleImageChange}
              onRemoveImage={handleRemoveImage}
              selectedVideo={selectedVideo}
              videoPreview={videoPreview}
              onVideoChange={handleVideoChange}
              onRemoveVideo={handleRemoveVideo}
              url={url}
              onUrlChange={setUrl}
            />
          </div>

          <div className="mt-6 pt-6 border-t border-gray-200">
            <button
              type="button"
              onClick={handleSendToSpecificUser}
              disabled={loading || !searchedUser || !hasContent}
              className="w-full md:w-auto px-6 sm:px-8 py-3 bg-red-500 text-white rounded-lg hover:bg-red-600 disabled:bg-gray-400 disabled:cursor-not-allowed text-xs md:text-sm font-semibold shadow-md transition-colors">
              {loading ? "Sending..." : "Send Message"}
            </button>
          </div>
        </div>
      )}

      {activeTab === "all" && (
        <div className="bg-white p-4 sm:p-6 rounded-xl shadow-xl min-w-0 overflow-x-hidden">
          <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-4 sm:mb-6">
            Send Promotional Message to All Users
          </h3>

          <SendToAllWarning />

          <MessageContentSection
            idPrefix="all"
            message={message}
            onMessageChange={setMessage}
            selectedImage={selectedImage}
            imagePreview={imagePreview}
            onImageChange={handleImageChange}
            onRemoveImage={handleRemoveImage}
            selectedVideo={selectedVideo}
            videoPreview={videoPreview}
            onVideoChange={handleVideoChange}
            onRemoveVideo={handleRemoveVideo}
            url={url}
            onUrlChange={setUrl}
          />

          <div className="mt-6 pt-6 border-t border-gray-200">
            <button
              type="button"
              onClick={handleSendToAllUsers}
              disabled={loading || !hasContent}
              className="w-full md:w-auto px-6 sm:px-8 py-3 bg-red-500 text-white rounded-lg hover:bg-red-600 disabled:bg-gray-400 disabled:cursor-not-allowed text-xs md:text-sm font-semibold shadow-md transition-colors">
              {loading ? "Sending to All Users..." : "Send to All Users"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
